import FirebaseDB from './firebase';
import { Redirects } from './GlobalContext';

const Campaign_Manager = (props) => {
    let parsed = props.match.params.campaignId;

    if (!parsed)
        parsed = { campaignId: "error", }
    else {

        parsed = { campaignId: parsed, };

        const db = new FirebaseDB();
        db.upload("landingSource", parsed);

        let redirect_path = Campaigns()[parsed.campaignId];

        if (redirect_path) {
            props.history.push(redirect_path);
        }
        else
            console.log("no campaign");
    }

    return null;
}

export default Campaign_Manager;


const Campaigns = () => {
    return (
        {
            facebookgeneral: Redirects().homepage,
            canonspecial01: "/static_page/c910",
            googlemaplink: Redirects().homepage
        }
    )
}